import { render, staticRenderFns } from "./google-index.vue?vue&type=template&id=c3ecbeaa&scoped=true&"
import script from "./google-index.vue?vue&type=script&lang=js&"
export * from "./google-index.vue?vue&type=script&lang=js&"
import style0 from "./google-index.vue?vue&type=style&index=0&id=c3ecbeaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ecbeaa",
  null
  
)

export default component.exports